"use strict";
exports.__esModule = true;
exports.DEFAULT_NOTIFICATIONS = void 0;
exports.DEFAULT_NOTIFICATIONS = {};
//# sourceMappingURL=model.js.map